const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the group list search directive
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('chipSegmentationSearch', ['Application', 'Categories', 'Groups', '$q', function (Application, Categories, Groups, $q) {
  return {
    restrict: 'E',
    scope: {
      selected: '=',
      onAddRemove: '='
    },
    template: require('../../templates/directives/chip-segmentation-search.html'),
    controller: ['$scope', function($scope) {
      const self = this;
      self.flags = Application.features.flags();
      
      self.options = [];
      self.selectedCategoryIds = [];
      self.selectedGroupIds = [];
      self.segmentation = {
        loading: false,
        term: '',
        removeTag: async function(segmentation) {
          try {
            for (let i = $scope.selected.length - 1; i >= 0; i--) {
              if (segmentation._id === $scope.selected[i]._id) {
                $scope.selected.splice(i, 1)
                break;
              }
            }
            await $scope.onAddRemove(segmentation, true);
          } catch (e) {
            console.error('Error removing segmentation: ', e);
          }

        },
        addTag: async function(segmentation) {
          self.options = [];
          self.segmentation.term = '';
          try {
           await $scope.onAddRemove(segmentation, false);
           $scope.selected.push(segmentation);
           if (segmentation.type === 'group') {
             self.selectedGroupIds.push(segmentation._id);
           } else {
             self.selectedCategoryIds.push(segmentation)
           }
          } catch (e) {
            console.error('Error adding segmentation: ', e);
          }
        }
      };

        let legacyName = function(item) {
          let parentName;
          let papaName;
  
          item.text = item.name;
          item.lineage_ids = [item._id];
  
          if (item.parent?.name) {
            parentName = item.parent.name + ' -> ';
            item.text = parentName + item.text;
          }
  
          if (item.parent?.parent?.name) {
            papaName = item.parent.parent.name + ' -> ';
            item.text = papaName + item.text;
          }
        };

      $scope.$watch('chipSegmentationSearch.segmentation.term', function(newVal, oldVal) {
        if (newVal === oldVal) {
          return;
        }

        if (!newVal) {
          self.options = []
          return;
        }
      
        let input = newVal;
        let deferred = $q.defer();

        input = input ? input.toLowerCase().replace(',', '.*') : '';

        self.options = [];
        let promises = [];

        if (!input) {
          return deferred.resolve([]);
        }

        const placeholders = {
          location: {name: 'Locations', text: 'Locations', _id: 'locations', placeholder: true},
          department: {name: 'Departments', text: 'Departments', _id: 'departments', placeholder: true},
          team: {name: 'Teams', text: 'Teams', _id: 'teams', placeholder: true},
          org_level: {name: 'Level', text: 'Level', _id: 'org_levels', placeholder: true},
          grade: {name: 'Grade', text: 'Grade', _id: 'grades', placeholder: true},
          group: {name: 'Group', text: 'Group', _id: 'group', placeholder: true}
        };

        const catQuery = {
          term: input,
          types: 'locations,departments,teams,grades,org_levels',
          ignoreSelections: false,
        };

        if (self.selectedCategoryIds?.length) {
          catQuery.selections = self.selectedCategoryIds.join(',');
        }

        promises.push(Categories.search(catQuery).$promise);

        if (self.flags.groups) {
          const groupQuery = {
            fields: '_id,name',
            name: '$regex,2,' + input + ',i'
          };
          if (self.selectedGroupIds?.length) {
            groupQuery._id = '$nin,' + self.selectedGroupIds.length + ',' + self.selectedGroupIds.join(',')
          }
          promises.push(Groups.find(groupQuery).$promise);
        }

        $q.all(promises)
        .then(function(results) {
          let cats = results[0];
          let groups = results[1] || [];

          let matches = {
            location: [],
            department: [],
            team: [],
            org_level: [],
            grade: []
          };

          cats.forEach(function(item) {
            let itemType;
            if (item.location) {
              itemType = 'location';
            } else if (item.department) {
              itemType = 'department';
            } else if (item.team) {
              itemType = 'team';
            } else if (item.org_level) {
              itemType = 'org_level';
            } else if (item.grade) {
              itemType = 'grade';
            } else if (item.category) {
              itemType = 'category';
            } else {
              itemType = '';
            }

            if (!itemType || !matches[itemType]) {
              return;
            }

            // Add legacy name
            legacyName(item);
            item.type = itemType;

            // Add item to matches type
            if (matches[itemType]) {
              matches[itemType].push(item);
            }
          });

          // Add requisite placeholder
          for (let key in matches) {
            if (matches[key].length) {
              self.options.push(placeholders[key]);
              self.options = self.options.concat(matches[key]);
            }
          }

          if (groups.length) {
            groups.forEach(function(group) {
              group.text = group.name;
              group.type = 'group';
            });

            self.options.push(placeholders.group);
            self.options = self.options.concat(groups);
          }

          deferred.resolve(self.options);
        });

        return deferred.promise;
      });

      self.initialize = function() {
        const selected = $scope.selected;
        for (const segmentation of selected) {
          if (segmentation.type === 'group') {
            self.selectedGroupIds.push(segmentation._id);
          } else {
            self.selectedCategoryIds.push(segmentation._id);
          }
        }
      }

      self.initialize();
    }],
    controllerAs: 'chipSegmentationSearch'
  };
}]);